// src/layout/PageWrapper.jsx
import React from "react";

export default function PageWrapper({ icon: Icon, title, right, children, maxWidth = "max-w-6xl" }) {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between border-b pb-3">
        <div className="flex items-center gap-3">
          {Icon ? <Icon className="h-6 w-6 text-black" /> : null}
          <h2 className="text-xl font-semibold tracking-tight">{title}</h2>
        </div>
        {right ? <div className="flex items-center gap-2">{right}</div> : null}
      </div>

      {/* Content container */}
      <div className={maxWidth}>{children}</div>
    </div>
  );
}
